import {Component, OnInit} from '@angular/core';
import {LgLogicObjectBaseComponent} from "../lg-logic-object-base.component";

@Component({
    selector: 'mvs-lg-logic-object-component-side',
    templateUrl: 'lg-logic-object-side.component.html',
    styleUrls: ['lg-logic-object-side.component.scss'],
    standalone: false
})
export class LgLogicObjectSideComponent extends LgLogicObjectBaseComponent implements OnInit {


    /**
     * load and initialize sidebar navigations
     */
    loadSideBarMenuItems() {
        this.navigationItems = [
            {
                label: 'Editor',
                action: 'editor',
                icon: 'fa-regular fa-square-code',
                tooltip: 'Editor',
                toggleable: false,
                default: true
            },
            {
                label: 'Variablen',
                action: 'variablen',
                icon: 'fa-regular fa-brackets-curly',
                tooltip: 'Variablen',
                toggleable: false,
                default: false
            },
            {
                label: 'Testen',
                action: 'testen',
                icon: 'fa-regular fa-flask-vial',
                tooltip: 'Testen',
                toggleable: false,
                default: false
            },
        ];

        this.activeNavigationItem = this.navigationItems[0];
        this.handleNavigationItemsChange();
    }
}
